import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class VisitService {

  constructor(
    private http: HttpClient
  ) { }

  get() {
    return this.http.get(environment.visitas);
  }

  create(form: FormGroup) {
    return this.http.post(environment.visitas, {
      "dsVisitas": {
        "ttvisitas": [
          form.value
        ]
      }
    });
  }

  delete(id: number, ven: number) {
    return this.http.post(environment.visitas + '?accion=B', {
      "dsVisitas": {
        "ttvisitas": [
          {
            ID: id,
            'ven-cod': ven
          }
        ]
      }
    });
  }

}
